function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunkSize = 8192;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}

function base64ToUint8Array(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export const generateEncryptionKey = (bits) => {
    const byteArray = new Uint8Array(bits / 8);
    window.crypto.getRandomValues(byteArray);
    return byteArrayToHex(byteArray);
};

export const generateShortEncryptionKey = (bits) => {
  const byteArray = new Uint8Array(bits / 8);
  window.crypto.getRandomValues(byteArray);
  return byteArrayToHex(byteArray).substring(0, 6);
};

export const byteArrayToHex = (byteArray) => {
    return Array.from(byteArray, (byte) => {
      return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('');
};

export const decryptData = async (encryptedData, encryptionKey, iv) => {
    if (encryptionKey.length !== 32) {
      encryptionKey = encryptionKey.padEnd(32, "0");
    }
    iv = stringToUint8Array(iv);
    try {
      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        new TextEncoder().encode(encryptionKey),
        { name: 'AES-GCM' },
        false,
        ['decrypt']
      );

      const decodedEncryptedData = base64ToUint8Array(encryptedData);

      const decryptedData = await window.crypto.subtle.decrypt(
        { name: 'AES-GCM', iv },
        cryptoKey,
        decodedEncryptedData
      );

      return new TextDecoder().decode(decryptedData);
    } catch (error) {
      console.error('Decryption error:', error);
      throw error;
    }
};

export const encryptData = async (data, encryptionKey, iv) => {
    if (encryptionKey.length !== 32) {
      encryptionKey = encryptionKey.padEnd(32, "0");
    }

    iv = stringToUint8Array(iv);
    try {
      const encodedData = new TextEncoder().encode(data);

      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        new TextEncoder().encode(encryptionKey),
        { name: 'AES-GCM' },
        false,
        ['encrypt']
      );

      const encryptedData = await window.crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        cryptoKey,
        encodedData
      );

      return arrayBufferToBase64(encryptedData);
    } catch (error) {
      console.error('Encryption error:', error);
      throw error;
    }
};

export const uint8ArrayToString = (uint8Array) => {
    return new TextDecoder('utf-8').decode(uint8Array);
};

export const stringToUint8Array = (stringData) => {
    return new TextEncoder('utf-8').encode(stringData);
};
